export default __webpack_public_path__ + "static/media/Category=Spektakl.032f9669.png";